import React from "react";
import { createFileRoute, useLocation } from "@tanstack/react-router";
import { createNoIndexMeta } from "~/lib/shared/meta";

function IntegrationsPage(): React.ReactElement {
  const location = useLocation();
  const rawSearch =
    typeof location.search === "string"
      ? location.search
      : typeof window !== "undefined"
        ? window.location.search
        : "";
  const statusParam = new URLSearchParams(rawSearch).get("status");

  return (
    <>
      <h1 className="font-heading text-3xl">Integrations</h1>
      {statusParam === "success" ? <p>Connection successful!</p> : null}
    </>
  );
}

export const Route = createFileRoute("/admin/integrations/")({
  head: () =>
    createNoIndexMeta(
      "Admin - Integrations – Dream Coach Match",
      "Admin integrations and external service connections",
    ),
  component: IntegrationsPage,
});
